// src/services/userService.js

import http from "./http";


const PagesServices = {
  //GET PROFILE
  
    getConfigById: async (configId) => {
    //   const queryString = new URLSearchParams(query).toString();
      try {
        
        const response = await http.GET(`pageconfig/search-by-id/${configId}`);
        // console.log('response111',response);
          if(response.status===200 && response.data){
            return response.data;
          }
        return null;
      } catch (error) {
        // console.error('Error fetching user:', error);
        throw error;
      }
    },getConfigByName: async (configId) => {
    //   const queryString = new URLSearchParams(query).toString();
      const params = new URLSearchParams(window.location.search);
      const isPublic = params.get('public') === 'true';
      const domainName = params.get('domain') || "apps.myship.ca";

      const url = isPublic
        ? `public-pages/${domainName}/${configId}`
        : `pageconfig/search-by-api-name/${configId}`;
      try {
        
        const response = await http.GET(url);
        // console.log('response111',response);
          if(response.status===200 && response.data){
            return response.data;
          }
        return null;
      } catch (error) {
        // console.error('Error fetching user:', error);
        throw error;
      }
    },
    getConfigVariablesList: async (configId, configApiName = '') => {
    //   const queryString = new URLSearchParams(query).toString();
      const params = new URLSearchParams(window.location.search);
      const isPublic = params.get('public') === 'true';
      const domainName = params.get('domain') || "apps.myship.ca";
      const url = isPublic && configApiName
        ? `public-pages/${domainName}/${configApiName}/pages-variable/paginated-search?pageConfigurationId=${configId}&search=&page=0&orderBy=&size=1000`
        : `pages-variable/paginated-search?pageConfigurationId=${configId}&search=&page=0&orderBy=&size=1000`;
      try {
        
        const response = await http.GET(url);
        // console.log('response111',response);
          if(response.status===200 && response.data){
            return response.data;
          }
        return null;
      } catch (error) {
        throw error;
      }
    },
    getLookupLayoutsByWindowId: async (windowId) => {
      try {
        const response = await http.GET(`field-groups/window/${windowId}/lookup-layouts`);
        if (response.status === 200 && response.data) {
          return response.data;
        }
        return null;
      } catch (error) {
        throw error;
      }
    },
    getConfigDirect : async (configId,postData) => {
      try{
        const response = await http.POST(`pageconfig/${configId}/direct-pages-config-execute`,postData);
           if(response.status===200 && response.data){
            // console.log('response1',response.data);
            return response.data;
          }
        return null;
      } catch (error) {
        // console.error('Error fetching user:', error);
        throw error;
      }
    },
    getConfigDirectHyperLink : async (configId,postData) => {
      try{
        const response = await http.POST(`pageconfig/${configId}/pages-config-execute-hyperlink`,postData);
           if(response.status===200 && response.data){
            return response.data;
          }
        return null;
      } catch (error) {
        throw error;
      }
    },
    // getProfile:  () => {
    //   const storedProfile = localStorage.getItem('userProfile');
    //     if (storedProfile) {
    //       // If it exists, parse and return it
    //       try{
    //         // console.log('storedProfile',storedProfile);
    //         return JSON.parse(storedProfile);
    //       }catch(e){

    //       }
    //     }
    // },
    // //get user by id 
    // getUserById: async (id) => {
    //   try {
        
    //     const response = await http.GET(`users/${id}`);
    //       if(response.code===200 && response.data){
    //         // UserService.storeProfile(resData.data);
    //         // console.log('resData.data',resData.data);
    //         return response.data;
    //     }
    //     return null;
    //   } catch (error) {
    //     // console.error('Error fetching user:', error);
    //     throw error;
    //   }
    // },
    // //Save user
    // saveUser:async (data)=>{
    //   try {
    //     const response = await http.POST(`users`,data)
    //     // console.log('response',response);
    //         if((response.code===200 || response.code===201) && response.data){
    //           return response.data;
    //         }else{
    //           return response;
    //         }
    //   } catch (error) {
    //     console.error('Error fetching user:', error);
    //     if(error.status){
    //       const resData = error.data;
    //       if(resData.code && resData.data){
    //           return resData;
    //       }
    //     }
        
    //     // throw error;
    //   }  
    // },

    //  //Save user
    //  updateUser:async (userId,data)=>{
    //   try {
    //     const response = await http.PUT(`users/${userId}`,data);
    //       if((response.code===200 || response.code===201) && response.data){
    //         return response.data;
    //       }else{
    //         return response;
    //       }
    //   } catch (error) {
    //     if(error.status){
    //       const resData = error.data;
    //       if(resData.code && resData.data){
    //           return resData;
    //       }
    //     }
    //     console.error('Error fetching user:', error);
    //     throw error;
    //   }  
    // },
    // updateUserProfile:async (userId,data)=>{
    //   try {
    //     const response = await http.PUT(`/update-profile/${userId}`,data);
    //       if((response.code===200 || response.code===201) && response.data){
    //         return response.data;
    //       }else{
    //         return response;
    //       }
    //   } catch (error) {
    //     if(error.status){
    //       const resData = error.data;
    //       if(resData.code && resData.data){
    //           return resData;
    //       }
    //     }
    //     console.error('Error fetching user:', error);
    //     throw error;
    //   }  
    // },
    // updateBulkUser:async (body)=>{
    //   try {
    //     const response = await http.PUT(`users  `,body);
    //     if(response.status===200 && response.data){
    //       const resData = response.data;
    //       return resData;
    //     }else{
    //       return response;
    //     }
    //   } catch (error) {
    //     if(error.status){
    //       const resData = error.data;
    //       if(resData.code && resData.data){
    //           return resData;
    //       }
    //     }
    //     console.error('Error fetching updateBulkUser:', error);
    //     throw error;
    //   }  
    // },
    // //Save user
    // deleteUser:async (userId)=>{
    //   try {
    //     const response = await http.DELETE(`users/${userId}`);
    //     return response;
    //   } catch (error) {
    //     if(error.status){
    //       const resData = error.data;
    //       if(resData.code && resData.data){
    //           return resData;
    //       }
    //     }
    //     console.error('Error fetching user:', error);
    //     throw error;
    //   }  
    // },
   
    // // STORE PROFILE
    // storeProfile: (data) => {
    //   localStorage.setItem('userProfile',JSON.stringify(data));
    // },
    // //REMOVE PROFILE
    // removeProfile: () => {
    //   // Remove the token from storage
    //   localStorage.removeItem('userProfile');
    // },
    // getUserStateList:async()=>{
    //   let defaultCountryCode='US';
    //  let response=await http.GET(`state-list/${defaultCountryCode}`);
    //  if (response.data && response.code===OK) {
    //   return response.data
    //  }
    //  else{
    //   return null;
    //  }
    // },
    // changePassword:async(data)=>{
    //   try {
    //   let response=await http.POST(`update-password`,data);
    //   return response;
    // }
    // catch(error){
    //   //
    // }
    // },
    
    // updateDarkMode:async (userId,data) => {
    //   const response = await http.PUT(`update-theme/${userId}`,data);
    //   if(response.code===200 && response.data){
    //     const resData = response.data;
    //     return resData;      
    //   }
    // }
    
  };
  
  export default PagesServices;